/* eslint no-use-before-define: 0 */
import { eAPPSTATE, PROVIDER_URL } from "./config/config.App";
import { EventClass, EventType } from "../_game/config/Events";
import { RGSActions } from "./config/config.Connections";

import { screenState } from "../_game/controllers/controller.Screen";

import Application from "./core.Application";
import LocalStorage from "./core.LocalStorage";
import EventDispatcher from "./core.EventDispatcher";
import UrlParams from "./core.UrlParams";
import ConnectionManager from "./core.ConnectionManager";
import Mobile from "./core.Mobile";
import Utils from "./core.Utils";
import { store } from "./core.Store";
import { getProviderConnection } from "./connections/ConnectionsController";
import AbstractCommManager from "./connections/AbstractCommManager";
import StoreManager from "./store/StoreManager";
import StoreComponent from "./components/store/StoreComponent";
import SoundManager from "./core.SoundManager";
import CurrencyFormat from "./core.CurrencyFormatter";
import { ErrorManager } from "./core.ErrorManager";
import Proxi from "./proxi/Proxi";
import ProxiProvider from "./proxi/Proxi.Provider";
import HTMLEvents from "./core.HTMLEvents";
import LangManager from "./core.LangManager";

import "../assets/css/normalize.css";
import "../assets/css/app.css";

/** Global Classes */
export let __App: Application;
export let __AppState: eAPPSTATE;
export let __LocalStorage: LocalStorage;
export let __EventDispatcher: EventDispatcher;
export let __UrlParams: UrlParams;
export let __ConnectionManager: ConnectionManager;
export let __CurrentConnection: AbstractCommManager;
export let __Store: any;
export let __StoreManager: StoreManager;
export let __Currency: CurrencyFormat;
export let __Utils: Utils;
export let __ErrorManager: ErrorManager;
export let __Proxi: Proxi;
export let __ProxiProvider: ProxiProvider;
export let __Mobile: Mobile;
export let __HTMLEvents: HTMLEvents;
export let __Lang: LangManager;
export let __SoundManager: SoundManager;

/** Global Variables */
export let LANDSCAPE: boolean;
export let IS_MOBILE: boolean;
//@ts-ignore
export const PROVIDER = "MARLIPIN"; //@todo
//@ts-ignore
export const VERSION = "1.0.1";
//@ts-ignore
export const CURRENT_LANG = "en_US";

export function __initialize() {
  // The main pixi.js application
  __App = new Application();

  //Mobile class
  __Mobile = new Mobile();

  //LocalStorage system
  __LocalStorage = new LocalStorage();

  LANDSCAPE = __Mobile.checkLandscape();
  IS_MOBILE = __Mobile.checkMobile();

  //HTML Events handlers
  __HTMLEvents = new HTMLEvents({
    onRezize: (_payload) => {
      LANDSCAPE = _payload.bLandscape;
      IS_MOBILE = _payload.lMobile;
    },
  });

  // General dispatcher of different type of events
  __EventDispatcher = new EventDispatcher();

  //URL params
  __UrlParams = new UrlParams();

  //Lang
  __Lang = new LangManager();

  //Class that handles the RGS connection (HTTP or WEBSOCKET)
  __ConnectionManager = new ConnectionManager();

  //Current API Connection
  __CurrentConnection = getProviderConnection();

  //Init Store
  __Store = store;

  //Store Manager
  __StoreManager = new StoreManager();

  //Currency
  __Currency = new CurrencyFormat();

  //Utils
  __Utils = new Utils();

  //Error Manager
  __ErrorManager = new ErrorManager();

  //Proxi
  __Proxi = new Proxi();

  //ProxiProvider
  __ProxiProvider = __Proxi.provider;

  //Sound Manager
  __SoundManager = new SoundManager();

  // Init application controller
  setState(eAPPSTATE.INITIALIZE);
}

__AppState = eAPPSTATE.NOT_SET;
// let storeChangeUnsubscribe = null;

/**
 * set Application state globaly
 * @param _newState {eAPPSTATE}
 */
export function setState(_newState: eAPPSTATE) {
  // let _oldState = __AppState;

  __AppState = _newState;
  // we write here the state we want to go to and we call setState at the end of setState so it executes everything
  let lateChangeStateTo: string = "";

  switch (_newState) {
    case eAPPSTATE.INITIALIZE:
      {
        const connStrategy = __CurrentConnection.getConnectionStrategy(
          (): any => {
            setState(eAPPSTATE.LOADING_SCRIPTS);
          },
          (): any => {
            __Lang.init({
              onReady: () => {},
            });
          }
        );

        __ConnectionManager.setConnectionStrategy(connStrategy);
        __ConnectionManager.init();
        // start heartbeat if wanted
        __ConnectionManager.startHeartbeat();
      }
      break;
    case eAPPSTATE.LOADING_SCRIPTS:
      //@todo Load PROXI File
      // if(__UrlParams.props.noWrapper === "true") {
      //   setState(eAPPSTATE.LOADING_PRELOADER);

      // }else {
      __Utils
        .loadJS(PROVIDER_URL.MARLIPIN, true)
        .catch(() => {
          setState(eAPPSTATE.LOADING_PRELOADER);
        })
        .then(() => {
          setState(eAPPSTATE.LOADING_PRELOADER);
        });
      // }
      break;
    case eAPPSTATE.LOADING_PRELOADER:
      __EventDispatcher.dispatch(
        EventClass.SYSTEM,
        EventType.SYSTEM.APP_CHAMGE_SCREEN,
        {
          screen: screenState.LOADING,
        }
      );
      __ProxiProvider.gameLoadingStarted();
      __Lang.init({
        onReady: () => setState(eAPPSTATE.RGS_LOGIN),
      });
      break;
    case eAPPSTATE.RGS_LOGIN:
      // handleStoreChange will change to next gamestate when receiving the LOGIN/OPEN answer
      // see the state that it transitions to in the actual function (should be LOADING_FONTS)
      __Store.subscribe(__handleStoreChange);
      //login to RGS
      __CurrentConnection.rgsLogin();
      break;
    case eAPPSTATE.RGS_INIT:
      {
        // we have the session ID here so we should be good for a init try
        // vendor class was loaded before this step
        const { sessionID } = __Store.getState().game.SESSION_DATA;

        __CurrentConnection.rgsInit(sessionID);
      }
      break;
    case eAPPSTATE.LOADING_FINAL:
      const cstate = store.getState();
      __Currency.setFormatOptions(cstate.game.SESSION_DATA.currency);
      __CurrentConnection.failedBets();
      //load sounds
      __SoundManager.load().then((a) => {
        setState(eAPPSTATE.BEFORE_INGAME);
      });

      //load current bets
      __CurrentConnection.getBets();
      break;
    case eAPPSTATE.BEFORE_INGAME:
      __EventDispatcher.dispatch(
        EventClass.SYSTEM,
        EventType.SYSTEM.APP_CHAMGE_SCREEN,
        {
          screen: screenState.GAME,
        }
      );

      __ProxiProvider.gameLoadingEnded();
      setState(eAPPSTATE.INGAME);
      break;
    case eAPPSTATE.INGAME:
      //Handle on screen controller
      __ProxiProvider.gameReady();
      __HTMLEvents.onResizeEvent();
      break;
  }

  __EventDispatcher.dispatch(
    EventClass.SYSTEM,
    EventType.SYSTEM.APP_CHANGED_STATE,
    { strState: __AppState }
  );

  if (lateChangeStateTo !== "") setState(lateChangeStateTo as eAPPSTATE);
}

function __handleStoreChange() {
  const _state = __Store.getState();
  let currdata = __ConnectionManager.getCurrentData();
  // open and init are queued, as soon as the INIT call returns we change state to INGAME
  if (
    __AppState === eAPPSTATE.RGS_LOGIN &&
    typeof currdata !== "undefined" &&
    _state.game.COMM_STATUS.bIsBusy === false &&
    currdata.COMMAND.type === RGSActions.LOGIN
  ) {
    if (currdata.ERROR_CODE === 0) {
      // change to next state
      setState(eAPPSTATE.RGS_INIT);
    }
  }

  // after receiving the INIT package just go on to next state
  if (
    __AppState === eAPPSTATE.RGS_INIT &&
    _state.game.COMM_STATUS.bIsBusy === false &&
    typeof currdata !== "undefined" &&
    currdata.COMMAND.type === RGSActions.INIT
  ) {
    if (currdata.ERROR_CODE === 0) {
      // change to next state
      setState(eAPPSTATE.LOADING_FINAL);
    }
  }

  // after receiving a setup call midgame
  if (
    __AppState === eAPPSTATE.RESUME_AFTER_FREEROUNDS &&
    _state.game.COMM_STATUS.bIsBusy === false &&
    currdata.COMMAND.type === RGSActions.INIT
  ) {
    setState(eAPPSTATE.INGAME);
  }
}

// - REDUX COMPONENT - adds instance to store manager
export const REDUX_REGISTER_COMPONENT = (_instance: StoreComponent) => {
  __StoreManager.registerComponent(_instance);
};

// - REDUX COMPONENT - removes instance from store manager
export const REDUX_DISPOSE_COMPONENT = (_instance: StoreComponent) => {
  __StoreManager.disposeComponent(_instance);
};

export const REDUX_DISPATCH_NOW = (changes: any) => {
  __StoreManager.storeChanges = 1;
  __StoreManager.handleTick();
};
